module.exports = "https://static.zego.com/_next/static/images/CarMoreFlexibility-7e4f8ddfab00becf39e4559ae76b1d56.jpg";